import React, { useState } from 'react';
import { connect } from "react-redux";

import LoginPage from './LoginPage';
import { useLogin } from './AuthUserContext';

import * as LoginActions from "./actions";

const LoginPageContainer = ({
  dispatch
}) => {
  const login = useLogin();
  const [ data, setData ] = useState({ emailAddress: "", password: "" });


  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleSubmit = e => {
    e.preventDefault();
    const emailAddress = data.emailAddress;
    const password = data.password;

    if (emailAddress === "" && password === "")
      return;

    if (emailAddress.includes('@'))
      dispatch(reportCorrectUsername(true));
    else {
      dispatch(reportCorrectUsername(false));
      e.target.reset();
      return;
    }

    login(emailAddress, password);
    e.target.reset();
  };

  return (
    <LoginPage
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
}

const reportCorrectUsername = correctUsername => {
  return {
    correctUsername: correctUsername,
    type: LoginActions.LOGIN_CHECK_USERNAME
  }
}


const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(LoginPageContainer);
